module.exports = __webpack_public_path__ + "img/foreword_3.1095b545.jpg";